import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--primary-email-lock"
//
// A contact created from HubSpot keeps its primary email — the first chip in the
// emails field — read-only: the address is its identity on the HubSpot side. The
// server refuses the change either way (ContactPersons::Update); this only saves
// the round trip by catching it before the form submits.
export default class extends Controller {
  static targets = ["error"]
  static values = { primary: String, message: String }

  check(event) {
    const select = this.element.querySelector('select[name="emails[]"]')
    if (!select) return

    // No current primary means there is nothing to protect, exactly as the server
    // decides it (ContactPersonsPrimaryEmailLock#primary_email_change?). Without
    // this, a phone-only anchored lead could never save any field at all.
    if (!this.primaryValue.trim()) {
      this.clearError()
      return
    }

    // Clearing the field removes the primary email, so an empty list is a change
    // just like a different first chip.
    const submitted = Array.from(select.selectedOptions)
      .map((option) => option.value)
      .filter((value) => value.trim() !== "")[0]

    if (
      submitted &&
      this.normalize(submitted) === this.normalize(this.primaryValue)
    ) {
      this.clearError()
      return
    }

    event.preventDefault()
    this.showError()
  }

  normalize(value) {
    return String(value).trim().toLowerCase()
  }

  showError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = this.messageValue
    this.errorTarget.hidden = false
    this.errorTarget.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  clearError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.hidden = true
  }
}
